import ReactDOM from 'react-dom/client';
import React from 'react';

import './styles/index.css';
import 'antd/dist/antd.css';

import App from './App';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
